<div
		class="fullscreen-content top-fullscreen-content"
		[@initialRouteAnimation]
		*ngIf="!navigationDone || !userService.loggedUser || connectionService.tokenLoading || connectionService.awaitUserData || connectionService.windowDisplayed || connectionService.checkingConnection">
	<div
			class="home-middle"
			*ngIf="navigationDone && !userService.loggedUser && !connectionService.tokenLoading && !connectionService.awaitUserData && !connectionService.windowDisplayed && !connectionService.checkingConnection; else spinner"
			>
		<div class="copo-notification">
			<div class="copo-cell-notification">
				<mat-icon svgIcon="alert" [attr.title]="'offline.alert' | translate"></mat-icon>
			</div>
			<div class="copo-cell-notification-padding">
				<span translate *ngIf="hasConnection">user.need.connection</span>
				<span translate *ngIf="!hasConnection">user.no.connection</span>
			</div>
		</div>
		<button type="submit" mat-raised-button color="primary" (click)="login()">
			<span translate>menu.sign.in</span>
		</button>
	</div>
	<ng-template #spinner>
		<copo-loading-spinner class="loading-spinner-container-padded"></copo-loading-spinner>
	</ng-template>
</div>
<router-outlet></router-outlet>